module.exports = __webpack_public_path__ + "62da3b74747a283438b9b0d62b8f0ac7.png";